import validate from "/builds/sbt/smsbat/node_modules/nuxt/dist/pages/runtime/validate.js";
import router_45global from "/builds/sbt/smsbat/middleware/router.global.ts";
import manifest_45route_45rule from "/builds/sbt/smsbat/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  router_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}